import { DashboardManager } from './dashboard-manager';
import { logger } from '../utils/logger';

let dashboardManager: DashboardManager | null = null;

/**
 * Set the dashboard manager instance
 * @param manager - DashboardManager instance to use
 */
export function setDashboardManager(manager: DashboardManager): void {
  dashboardManager = manager;
}

/**
 * Get the dashboard manager instance
 * @throws Error if dashboard manager is not initialized
 * @returns DashboardManager instance
 */
export function getDashboardManager(): DashboardManager {
  if (!dashboardManager) {
    throw new Error('DashboardManager not initialized. Call setDashboardManager first.');
  }
  return dashboardManager;
}
